import { connect } from "react-redux";
import HeaderTitle from "header/components/title";

const mapStateToProps = () => {
  return {
    title: "Bummer...",
  };
};

export default connect(mapStateToProps)(HeaderTitle);
